import { adminOrderMemoModal } from "@/atoms/order/admin-order-memo-modal";
import { EditMemoButton } from "@/page/order/AdminOrderDetail/_componant/EditMemoButton";
import { CartItemDto } from "@/types/dto/cart-item-dto";
import { useSetRecoilState } from "recoil";

function AdminMemoEdit({ item }: { item: CartItemDto }) {
  const setModal = useSetRecoilState(adminOrderMemoModal);

  if (!item.memoItems || item.memoItems.length === 0) {
    return null;
  }
  return (
    <EditMemoButton
      onClick={() => {
        setModal(item);
      }}
    />
  );
}

export default AdminMemoEdit;
